

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LabWorkOrderParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;

}
export const labStatus = {
  OPEN: 'Open',
  INPROGRESS: 'In-Progress',
  COMPLETED: 'Completed'
};

export interface LabWorkOrder {
  regMst?: any;
  
  id?:any;
  labWorkOrderId?:number,// - Int (primary key)
  regId:string,         // - guid -mandatory
  admId?:number,         // - int- optional
  visitId:number,       // - int - mandatory
  orderDateTime:any,   // - datetime- mandatory
  orderPriority:string, // - varchar(20) - Regular, Emergency - varchar(20) -mandatory
  woStatus:string,      // - varchar(20) - New, Sample Collected, Result Inprogress ,Result Done - mandatory
  woFrom:string,        // - varchar(20) - OP, IP Ward, Online - mandatory
  referenceNo:number,  // - int -mandatory
  referenceDate:Date    //- datetime-mandatory

  tenantId: string;
  branchId: string;
  completedDate?:any;
  sampleCollectedDate?:Date;

  labWorkOrderDetDto?:any[];
  labWorkOrderRegDto?:any[];
  type?:string;
  //From & To Date Added by Raja 25-12-21
  fromDate?:string;
  toDate?:string;
  //Fields Added for estimated time calculation - 05-04
  days?:string;
  hours?:string;
  mins?:string;
  serviceTrackStatus?:string;
  billId?:number;
  name?:string;
  sampleTypes?:string[];
  refId?:string;

  serviceId?:string;
  detid?:number;
  barcode?:string;
  Qty?:number;
  PatientOrder?:any[];
  physician?:string;
  woId?:number;
  dpRegId?:string;
  IsSampleBasedBarcode?:boolean;
  sampleCount?:number;
  createdBy?:number;
}




export abstract class LabWorkOrderData {

  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<LabWorkOrder[]>;
  abstract getById(url: string): Observable<any>;
  abstract create(url: string,data: LabWorkOrder): Observable<any>;
  abstract createLabMaster(url: string,data: any): Observable<any>;
  abstract updateLabMaster(url: string,data: any): Observable<any>;
  abstract update(url: string,data: LabWorkOrder): Observable<any>;
  abstract delete(url: string): Observable<any>;

  abstract searchList(url: string,data:any): Observable<any>;
  abstract sendMessage(url: string, data: any): Observable<any>;
  abstract sendgreetingsMessage(url: string, data: any): Observable<any>;
  abstract send_email(url: string, data:any): Observable<any[]>;
  abstract labWorkOrderQueue(url: string): Observable<any[]>;

  abstract createHomeCollection(url: string,data: any): Observable<any>;
  abstract listCollectionMode(url: string): Observable<any>;
  abstract updateWorkOrder(url: string): Observable<any>;
  abstract BackDatedWorkOrderDto(url:string,data:any):Observable<any>;

}
